import { useFormik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { getSinglePolicyDetails } from "../../../redux/slice/policy/policySlice";
import {
  makePayment,
  resetTransactionStatus,
  reverseTransaction,
} from "../../../redux/slice/transaction/transactionSlice";

const PayPremium = ({
  customer_id,
  policy_id,
  policy_app_no,
  editing,
  setEditing,
  transactionDetails,
  setTransactionDetails,
}) => {
  const close = useRef();

  const { state } = useLocation();

  const { user, user_permissions } = useSelector((state) => state.auth?.user);
  const { isSuccess } = useSelector((state) => state.transaction);
  const { customer_policy_details } = useSelector((state) => state.policy);

  const [reversePayment, setReversePayment] = useState();

  const today = new Date().toISOString().split("T")[0];

  const dispatch = useDispatch();

  const onSubmit = (values, { resetForm }) => {
    dispatch(makePayment(values));
  };

  const validationScehma = Yup.object().shape({
    payment_date: Yup.string("Payment Date must be a string").required(
      "Date cannot be blank"
    ),
    part_premium: Yup.number().required("Amount cannot be blank"),
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      payment_date: editing ? transactionDetails?.payment_date : "",
      desc:
        editing && transactionDetails?.desc !== null
          ? transactionDetails?.desc
          : "",
      part_premium: editing ? transactionDetails?.part_premium : "",
      policy_id: customer_policy_details?.policy_app_rsk?.[0]?.policy_id,
      policy_app_no:
        customer_policy_details?.policy_app_details?.policyAppNumber,
      staff_id: user?.staff_id,
      customer_id: customer_policy_details?.policy_app_details?.customerId,
    },
    validationSchema: validationScehma,
    onSubmit,
  });

  useEffect(() => {
    if (isSuccess) {
      close.current.click();
      dispatch(
        getSinglePolicyDetails({
          customer_id: state?.customerId,
          policy_number: state?.policyAppNumber,
        })
      );
      setTransactionDetails && setTransactionDetails(null);
      dispatch(resetTransactionStatus());
    }
  }, [
    dispatch,
    isSuccess,
    resetForm,
    setTransactionDetails,
    state?.customerId,
    state?.policyAppNumber,
  ]);

  useEffect(() => {
    setReversePayment(
      user_permissions?.some(
        (permission) => permission.name === "Reverse payment"
      )
    );
  }, [user_permissions]);

  return (
    <div>
      <div className='modal-header'>
        <h4 className='modal-title text-primary-1' id='myLargeModalLabel'>
          Pay Premium
        </h4>
        <span
          type='button'
          className=' bg-gray hover rounded-circle border-none'
          data-bs-dismiss='modal'
          aria-hidden='true'
          ref={close}
          onClick={() => {
            resetForm();
            setEditing && setEditing(false);
            setTransactionDetails && setTransactionDetails(null);
          }}
          style={{ padding: "0px 3px" }}
        >
          <i
            className='mdi mdi-close text-white'
            style={{ fontSize: "16px" }}
          ></i>
        </span>
      </div>
      <div className='modal-body'>
        <form onSubmit={handleSubmit}>
          <div className='row mb-3'>
            <div className='col-md-12 sm-text-end'>
              <label htmlFor='amount' className={`form-label mt-1`}>
                Amount<span className='text-danger'>*</span>
              </label>
            </div>
            <div className='col-md-12'>
              <input
                type='number'
                name='part_premium'
                className='form-control form-control-sm'
                id='part_premium'
                value={values?.part_premium}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={editing}
              />
              {errors?.part_premium && touched?.part_premium && (
                <p className='text-danger mb-0'>{errors?.part_premium}</p>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-sm-12'>
              <label for='status_date' className='col-form-label'>
                Date<span className='text-danger'>*</span>
              </label>
            </div>
            <div class='col-sm-12'>
              <input
                type='date'
                name='payment_date'
                max={today}
                className='form-control form-control-sm'
                id='payment_date'
                value={values?.payment_date}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={editing}
              />
              {errors?.payment_date && touched?.payment_date && (
                <p className='mb-0 text-danger'>{errors?.payment_date + "*"}</p>
              )}
            </div>
          </div>
          <div className='row mb-3'>
            <div className='col-md-12 sm-text-end'>
              <label for='last_name' className='col-form-label'>
                Description
              </label>
            </div>
            <div className='col-sm-12'>
              <textarea
                disabled={editing}
                name='desc'
                className='form-control form-control-sm'
                id='desc'
                value={values?.desc}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
          <div className='d-flex justify-content-end gap-3'>
            <button
              type='button'
              ref={close}
              className='btn btn-sm mt-2 px-3 text-muted'
              data-bs-dismiss='modal'
              style={{ background: "#F1F0F1" }}
              onClick={() => {
                resetForm();
                setEditing && setEditing(false);
                setTransactionDetails && setTransactionDetails(null);
              }}
            >
              Cancel
            </button>
            {!editing && (
              <button
                type='submit'
                className='btn btn-primary btn-sm mt-2 px-3'
                data-bs-dismiss='modal'
              >
                Make Payment
              </button>
            )}
            {editing &&
              reversePayment &&
              transactionDetails?.transaction_type !== "credit reversed" &&
              transactionDetails?.transaction_type !== "claim processed" &&
              transactionDetails?.complete_payment && (
                <button
                  type='button'
                  className='btn btn-danger btn-sm mt-2 px-3 text-white'
                  onClick={() =>
                    dispatch(
                      reverseTransaction({transaction_id:transactionDetails?.transaction_id, policy_app_no: transactionDetails.policy_app_no, customer_id: transactionDetails.customer_id})
                    )
                  }
                >
                  Reverse
                </button>
              )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayPremium;
